import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CreateVehicle, CatalogVehicleType, VehicleTypeCatalog, } from '../../../core/api/assignment-employee/catalog';
import { ApiUrlService } from '../apiUrl/api-url.service';

@Injectable({
    providedIn: 'root'
})

export class CatalogService {



    private apiVehicleType: string;

    constructor(private http: HttpClient, private apiUrlService: ApiUrlService) {

        this.apiVehicleType = this.apiUrlService.apiVehicleTypeData();

    }

    // CRUD VEHICLE TYPE
    getVehicleTypeCatalog(): Observable<VehicleTypeCatalog> {
        return this.http.get<VehicleTypeCatalog>(this.apiVehicleType);
    }
    addVehicleType(newItem: CreateVehicle): Observable<CatalogVehicleType> {
        return this.http.post<CatalogVehicleType>(this.apiVehicleType, newItem);
    }
    updateVehicleType(updatedItem: CatalogVehicleType): Observable<CatalogVehicleType> {
        return this.http.put<CatalogVehicleType>(`${this.apiVehicleType}/${updatedItem.id}`, updatedItem);
    }
    deleteVehicleType(id: string): Observable<void> {
        return this.http.delete<void>(`${this.apiVehicleType}/${id}`);
    }


}
